import { React, useState, useEffect } from "react";
import { Modal, TextField, MenuItem, Fade, InputAdornment } from "@mui/material";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import request from "../../../../Helpers/API";
import { ValSpecialCharacters } from "../../../../Validators/ValSpecialCharacters";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";

const ModalGestionClienteJuridco = ({ open, onClose, facturasSeleccionadas, onSave, idcliente, saldo, moratorios, interespactado, total, responsable }) => {
    const [gestion, setGestion] = useState({
        mediocontacto: "",
        gestion: "",
        objecion: ""
    });

    const [objeciones, setObjeciones] = useState([]);
    const [comentarios, setComentarios] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // Estado para controlar el modal de Generar Convenios
    const [openGenerarConvenioModal, setOpenGenerarConvenioModal] = useState(false);

    // Maneja la apertura del modal de Generar Convenios
    const handleOpenGenerarConvenioModal = () => {
        onClose(); // Cierra el modal actual
        setOpenGenerarConvenioModal(true); // Abre el modal de Generar Convenios
    };

    // Maneja el cierre del modal de Generar Convenios
    const handleCloseGenerarConvenioModal = () => {
        setOpenGenerarConvenioModal(false);
    };

    const [openRegistrarComentarioModal, setOpenRegistrarComentarioModal] = useState(false);

    // Maneja la apertura del modal de Generar Convenios
    const handleOpenRegistrarComentarioModal = () => {
        onClose(); // Cierra el modal actual
        setOpenRegistrarComentarioModal(true); // Abre el modal de Generar Convenios
    };

    // Maneja el cierre del modal de Generar Convenios
    const handleCloseRegistrarComentarioModal = () => {
        setOpenRegistrarComentarioModal(false);
        onClose();
    };

    const handleRegresarDesdeComentario = () => {
        setOpenRegistrarComentarioModal(false); // Cierra el modal de comentarios
        setTimeout(() => {
            open = true; // Reabre el modal de medio de contacto
        }, 300); // Ajusta el tiempo si es necesario para la animación de cierre del modal
    };

    const handleOpenModal = () => {
        onClose(); // Cierra el modal actual
        if (gestion.gestion === "C") {
            setOpenGenerarConvenioModal(true); // Abre el modal de Generar Convenios
        } else if (gestion.gestion === "M") {
            setOpenRegistrarComentarioModal(true); // Abre el modal de Registrar Comentario
        }
    };

    const [openMedioContactoModal, setOpenMedioContactoModal] = useState(open);

    const handleClose = () => {
        setOpenMedioContactoModal(false);
        onClose();
    };

    useEffect(() => {
        request
            .get(
                `ObjecionesPago/MostrarObjeciones`
            )
            .then((result) => {
                setObjeciones(result);
                return;
            })
            .catch((error) => {
                return;
            });
    }, [open]);

    const onChange = (prop, value, sbool, smensaje) => {
        setComentarios(value);
    };
    // console.log(objeciones)

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const handleSave = () => {
        onSave(); 
    };

    const onGuardar = () => {
        if (facturasSeleccionadas.length === 0) {
            Swal.fire({
                title: "CONVENIO DE PAGO",
                text: "Debes seleccionar al menos una factura.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        if (comentarios === undefined || comentarios === null || comentarios === "") {
            Swal.fire({
                title: "Gestion Juridico",
                text: "Los Comentarios son obligatorios",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }
        // setLoader({ ...loader, mostrar: true });
        const post = {
            estatus: "R",
            comentarios: comentarios,
            detalle: JSON.stringify(facturasSeleccionadas),
            idcliente: idcliente,

        };
        setLoader({ ...loader, mostrar: true });
        request
            .post(`ClientesEnviarJuridico`, post)
            .then(async (result) => {
                // setLoader({ ...loader, mostrar: false });
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "Gestion Juridico",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                handleSave();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                // setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    };

    return (
        <>
            {/* Modal para Registrar Contacto */}
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropProps={{
                    timeout: 300,
                }}
            // Usamos el componente Fade como la transición del contenido del modal
            >
                <Fade in={open}>
                    <div className="plantilla-screen-filtro-container-modal-container">
                        <div className="agregar-contacto-modal">
                            <div className="agregar-contacto-modal-detalle">
                                <div className="agregar-contacto-modal-detalle-formulario">
                                    <div className="agregar-contacto-modal-formulario-plantilla">
                                        <div
                                            className="plantilla-screen-filtro-container"
                                            id="mdlFiltros-modal"
                                        >
                                            <PlantillaScreen
                                                titulo={`Registrar Gestión`}
                                                className_main={1}
                                                className={"plantilla-screen-filtro-container-modal"}
                                            >
                                                <div className="cerrar-modal-button" onClick={onClose}>
                                                    X
                                                </div>
                                                <div
                                                    className={`agregar-contacto-modal-formulario-plantilla-agregar`}
                                                >
                                                    <div className="agregar-contacto-modal-formulario-plantilla-container scroll-4">

                                                        {/* <TextField
                                                            className="input-gestion"
                                                            fullWidth
                                                            size="small"
                                                            label="Gestión"
                                                            select
                                                            type="text"
                                                            value={gestion.gestion}
                                                            onChange={(e) => {
                                                                setGestion({
                                                                    ...gestion,
                                                                    gestion: e.target.value,
                                                                });
                                                            }}
                                                            sx={{ mt: 2 }}
                                                        >
                                                            <MenuItem value={"J"}>Enviar a Juridico</MenuItem>
                                                            <MenuItem value={"C"}>Enviar a Cobranza</MenuItem>
                                                        </TextField> */}

                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            label={"Comentarios"}
                                                            className="cel-1"
                                                            multiline
                                                            rows={3}
                                                            type="text"
                                                            // error={condiciones.bcondiciones}
                                                            onChange={({ target }) => {
                                                                ValSpecialCharacters(
                                                                    "comentarios",
                                                                    target.value,
                                                                    onChange,
                                                                    true,
                                                                    500
                                                                );
                                                            }}
                                                            sx={{ mt: 2 }}
                                                            value={comentarios}
                                                        />

                                                    </div>
                                                    <div className="agregar-contacto-modal-buttons">
                                                        <button
                                                            className="agregar-contacto-modal-button-guardar"
                                                            onClick={() => onGuardar()}
                                                        >
                                                            Guardar
                                                        </button>
                                                    </div>
                                                </div>
                                            </PlantillaScreen>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
            <LoaderScreen loader={loader} />
        </>
    );
};

export default ModalGestionClienteJuridco;